<template lang="pug">
    .value-swiper
      .value-swiper__navigation
        .value-swiper__navigation-arrow.value-swiper__navigation-arrow--left
          icon(
            name="long-arrow-left",
            size="32px"
          )
        .value-swiper__navigation-arrow.value-swiper__navigation-arrow--right
          icon(
            name="long-arrow-right",
            size="32px"
          )
      .value-swiper__wrapper
        swiper(
          ref="valueProps"
          :options="swiperOptions"
        )
          swiper-slide.value-swiper__slide(
            v-for="prop in valueProps" :key="prop.id"
          )
            img.value-swiper__slide-image(
              v-if="prop.valueImage"
              :src="prop.valueImage",
              :alt="prop.valueTitle")
            h6.value-swiper__slide-title(
              v-if="prop.valueTitle"
              v-html="prop.valueTitle"
            )
            .value-swiper__slide-description(
              v-if="prop.valueDescription"
              v-html="prop.valueDescription"
            )
            a.value-swiper__slide-link(
              v-if="prop.valueCtaText && prop.valueCtaUrl"
              :href="prop.valueCtaUrl"
              :title="prop.valueCtaText"
            ) {{ prop.valueCtaText }}
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import 'swiper/swiper.scss';

  export default {
    name: 'ValueProps',
    components: {
      Icon,
      swiper,
      swiperSlide,
    },
    props: {
      valueProps: {
        type: Array,
        default: () => [
          {
            valueImage: String,
            valueTitle: String,
            valueDescription: String,
            valueCtaText: String,
            valueCtaUrl: String,
          },
        ],
      },
    },
    data() {
      return {
        swiperOptions: {
          loop: true,
          slidesPerView: this.valueProps.length,
          slidesPerGroup: 1,
          spaceBetween: 40,
          navigation: {
            nextEl: '.value-swiper__navigation-arrow--right',
            prevEl: '.value-swiper__navigation-arrow--left',
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 50,
            },
          },
        },
      };
    },
    computed: {
      swiper() {
        return this.$refs.valueProps.$swiper;
      },
    },
  };
</script>

<style scoped lang="scss">
  .value-swiper {
    position: relative;
  }

  .value-swiper__navigation {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: index($featured-collection, 'carousel__nav');
    width: 100%;
    transform: translateX(-50%);
    justify-content: space-between;

    @include tablet-up {
      display: none;
    }
  }

  .value-swiper__navigation-arrow {
    display: flex;
    align-items: center;
  }

  .value-swiper__wrapper {
    position: relative;
    padding-top: ($spacing-unit * 7.5);

    @include tablet-up {
      padding-top: ($spacing-unit * 15);
    }
  }

  .value-swiper__slide {
    text-align: center;
  }

  .value-swiper__slide-image {
    margin: ($spacing-unit * 6) 0 ($spacing-unit * 3) 0;
    max-width: ($spacing-unit * 20);
  }

  .value-swiper__slide-title {
    text-transform: capitalize;
  }

  .value-swiper__slide-description {
    margin: 0 auto;
    margin-bottom: ($spacing-unit * 4);
    max-width: ($spacing-unit * 57);
  }

  .value-swiper__slide-link {
    text-transform: uppercase;
  }
</style>
